import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { Log } from "ng2-logger";
import { FormType } from "@app/tool/details/components/form-type.enum";
import { LifecycleFormComponent } from "@app/tool/details/components/forms/lifecycle-form/lifecycle-form.component";
import { ToolDetails } from "@app/tool/model/toolDetails.model";

import * as _ from 'lodash';

@Component({
    selector: 'app-lifecycle-form-modal',
    templateUrl: './lifecycle-form-modal.component.html',
    styleUrls: ['./lifecycle-form-modal.component.scss']
})
export class LifecycleFormModalComponent {
    _logger = Log.create(LifecycleFormModalComponent.name);

    @ViewChild(ModalComponent, {static: false}) modal: ModalComponent;
    @ViewChild(LifecycleFormComponent, {static: false}) lifecycleForm: LifecycleFormComponent;

    @Input() toolDetails: ToolDetails;
    @Input() isLoading: boolean;
    @Output() updateLifecycle = new EventEmitter<any>();

    showValidations = false;

    constructor() {
    }

    open() {
        this.reset();
        this.modal.open();
    }

    close() {
        this.reset();
    }

    clickUpdate() {
        if (!this.isFormValid()) {
            this._logger.info('clickEquipmentUpdate:: Form is invalid');
            return;
        }
        const lifecycle = this.lifecycleForm.value();

        this._logger.info('clickUpdate:: Lifecycle', lifecycle);

        this.updateLifecycle.emit({
            type: FormType.LIFECYCLE,
            lifecycle: _(lifecycle).omitBy(_.isNil).omitBy(_.isNaN).value()
        });
    }

    private reset() {
        this.showValidations = false;

        if (this.lifecycleForm) {
            this.lifecycleForm.reset();
        }
        this.modal.close();
    }

    private isFormValid() {
        this.showValidations = true;
        return this.lifecycleForm.isFormValid();
    }
}
